module.exports = __webpack_public_path__ + "img/Who-We-Are-Section-2-BG.f48fd469.jpg";